import { useEffect } from "react";

export const usePageMeta = (title, description, path = "/") => {
  useEffect(() => {
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", `https://netoolrepair.co.uk${path}`);
  }, [title, description, path]);
};
